import { render, staticRenderFns } from "./OrderSignOff.vue?vue&type=template&id=4c831a37&"
import script from "./OrderSignOff.vue?vue&type=script&lang=js&"
export * from "./OrderSignOff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports